import { ago, issueKey } from '../format.ts';
import { nameOf } from '../types.ts';
import type { IssueCard } from '../types.ts';
import { PriorityLabel, StatusMark, TagChip } from './Marks.tsx';

/**
 * One issue as a list row or, with `compact`, a board card. The same live row either way.
 *
 * The row opens the issue, and the tags in it search for themselves — two targets, so the one
 * that covers the whole row is a button STRETCHED over it rather than wrapped around it: an
 * interactive element cannot nest inside another. Everything but the tags is inert
 * (`pointer-events` in `styles.css`), so a click anywhere else on the row still lands on it.
 */
export function IssueRow({ issue, selected, compact, onOpen, onSearchTag }: { issue: IssueCard; selected: boolean; compact?: boolean; onOpen: (id: string) => void; onSearchTag: (name: string) => void }) {
  return (
    <li className={`issue-row${compact ? ' card' : ''}${selected ? ' selected' : ''}`}>
      <button
        type="button" className="issue-open" aria-current={selected || undefined}
        aria-label={`${issueKey(issue.id)} — ${issue.title}`}
        onClick={() => onOpen(issue.id)}
      />
      <StatusMark status={issue.status} />
      <span className="issue-key">{issueKey(issue.id)}</span>
      <span className="issue-title">{issue.title}</span>
      <span className="issue-tags">{(issue.tags ?? []).map(tag => <TagChip key={tag.id} name={tag.name} onSearch={() => onSearchTag(tag.name)} />)}</span>
      <span className="issue-meta">
        <PriorityLabel priority={issue.priority} />
        <span className="issue-owner">{nameOf(issue.owner, issue.ownerId)}</span>
        <span className="issue-comments" title={`${issue.commentCount} comments`}>{issue.commentCount} ✎</span>
        <span className="issue-time">{ago(issue.updatedAt)}</span>
      </span>
    </li>
  );
}
